module.exports = __webpack_public_path__ + "static/media/omanlog.90e30b3f.png";